/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface TasksKitSubmitBtnSignature {
  Args: {
    disabled?: boolean;
    fullWidth?: boolean;
    hideSpinner?: boolean;
    loading?: boolean;
    onClick: () => void;
    subtle?: boolean;
  };
  Element: HTMLElement;
}

const TasksKitSubmitBtnComponent = templateOnlyComponent<TasksKitSubmitBtnSignature>();

export default TasksKitSubmitBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::SubmitBtn': typeof TasksKitSubmitBtnComponent;
    'tasks-kit/submit-btn': typeof TasksKitSubmitBtnComponent;
  }
}
